import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/patientService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchPatients = createAsyncThunk("patients/fetchAll", async (params) => {
  const res = await svc.getPatients(params);
  return res.data;
});

export const createPatientThunk = createAsyncThunk("patients/create", async (data, { rejectWithValue }) => {
  try {
    const res = await svc.createPatient(data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to save patient."));
  }
});

export const updatePatientThunk = createAsyncThunk("patients/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updatePatient(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to save patient."));
  }
});

export const deletePatientThunk = createAsyncThunk("patients/delete", async (id, { rejectWithValue }) => {
  try {
    await svc.deletePatient(id);
    return id;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to delete patient."));
  }
});

const patientSlice = createSlice({
  name: "patients",
  initialState: { list: [], loading: false, error: null, selected: null },
  reducers: {
    setSelectedPatient: (state, action) => { state.selected = action.payload; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPatients.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchPatients.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchPatients.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createPatientThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updatePatientThunk.fulfilled, (state, action) => {
        const idx = state.list.findIndex((p) => p.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deletePatientThunk.fulfilled, (state, action) => {
        state.list = state.list.filter((p) => p.id !== action.payload);
      });
  },
});

export const { setSelectedPatient } = patientSlice.actions;
export default patientSlice.reducer;
